<template>
    <div class="grid grid-cols-1 gap-x-4 gap-y-3 px-2 py-2 sm:grid-cols-3">
        <div class="flex items-center">
            <span class="text-sm text-gray-700">
                {{ label }}
            </span>
        </div>
        <div>
            <BaseInputSelect
                v-model="knowledge"
                :name="props.name + '_knowledge'"
                class="py-2"
                :options="investmentKnowledgeOptions"
                label=""></BaseInputSelect>
        </div>
        <div class="flex justify-center">
            <BaseInputRadio v-model="experience" :name="props.name + '_experience'" :options="yesNoOptions" label="" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { useVModels } from '@vueuse/core'
import { yesNoOptions } from '../../../../data'
import BaseInputRadio from '../../../base/BaseInputRadio.vue'
import BaseInputSelect from '../../../base/BaseInputSelect.vue'
import { computed } from 'vue'
import { InvestmentKnowledgeOption } from '../../../../typings'
import { i18n } from '../../../../localization'
import { initializeNaturalWidgetForm } from './forms'
const props = defineProps<{
    experience: boolean
    knowledge: string
    name: string
    label: string
}>()
const emit = defineEmits(['update:experience', 'update:knowledge'])

const { experience, knowledge } = useVModels(props, emit)

const investmentKnowledgeOptions = computed(() => {
    return Object.keys(InvestmentKnowledgeOption).map((key) => {
        return {
            key: key,
            label: i18n.global.t('investment_knowledge.' + InvestmentKnowledgeOption[key]),
        }
    })
})
</script>
